import { Auth } from '@aws-amplify/auth';
import axios from 'axios';
import { LAST_LOGIN_TIMESTAMP } from "../constants";
import dayjs from "dayjs";
import { checkIfSessionExpired } from "../utils/helpers";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(async (config) => {
  try {
    const currentUser = await Auth.currentAuthenticatedUser();
    const currentSession = await Auth.currentSession();

    const isExpired = checkIfSessionExpired();

    let jwt = currentSession.getAccessToken().getJwtToken();

    if (!isExpired) {
      localStorage.setItem(LAST_LOGIN_TIMESTAMP, dayjs().toISOString());
      const refreshSessionPromise = new Promise<string>((resolve, reject) => {
        currentUser.refreshSession(currentSession.getRefreshToken(), (err: any, result: any) => {
          if (err || !result?.accessToken?.jwtToken) {
            reject(err ?? new Error('Failed to refresh session'));
            return;
          }
          resolve(result.accessToken.jwtToken);
        });
      });

      jwt = await refreshSessionPromise;
    }

    config.headers.Authorization = `Bearer ${jwt}`;
    return config;
  } catch (_err) {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = '/login';
    return Promise.reject(new Error('Session expired. Please log in again.'));
  }
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
